module.exports = __webpack_public_path__ + "aed19d11faabd1e0f80fbdf334baaa1e.jpg";